import PropTypes from 'prop-types';
import { RefreshCw } from 'lucide-react';

import { cn } from '#/lib/utils';
import { Button } from '#/modules/commonComponents/button';

/**
 * FloatingSelect 旁的重載按鈕列（對齊 v1 物料表單 refresh；不觸發整頁 F5）。
 */
const LookupRefreshField = ({
  onRefresh,
  isRefreshing = false,
  ariaLabel,
  children,
  className = null,
  disabled = false,
}) => (
  <div className={cn('flex items-start gap-2', className)}>
    <Button
      type="button"
      variant="default"
      size="icon"
      className="mt-1.5 shrink-0"
      onClick={onRefresh}
      disabled={disabled || isRefreshing}
      aria-label={ariaLabel}
    >
      <RefreshCw
        className={cn(isRefreshing && 'animate-spin')}
        size={20}
        aria-hidden
      />
    </Button>
    <div className="min-w-0 flex-1">{children}</div>
  </div>
);

LookupRefreshField.propTypes = {
  onRefresh: PropTypes.func.isRequired,
  isRefreshing: PropTypes.bool,
  ariaLabel: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
};

export default LookupRefreshField;
